import { useSubscription } from '@/hooks/useSubscription';
import { Card } from '@/components/ui/card';
import { Lock } from 'lucide-react';
import Layout from '@/components/Layout';

const TIER_LABELS = { essential: 'Essential', standard: 'Standard', pro: 'Pro' };

/**
 * FeatureGate — blocks a route when the workshop's subscription tier does
 * not include `feature`. Super Admins always pass (backend bypass).
 */
export const FeatureGate = ({ feature, children }) => {
  const { loaded, hasFeature, catalog, subscription } = useSubscription();
  if (!loaded) return null;
  if (hasFeature(feature)) return children;
  const needed = TIER_LABELS[catalog?.[feature]] || 'a higher';
  return (
    <Layout>
      <div className="flex items-center justify-center min-h-[60vh] p-6" data-testid="feature-gate-blocked">
        <Card className="max-w-md w-full p-8 text-center space-y-4">
          <div className="mx-auto w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center">
            <Lock className="h-7 w-7 text-amber-600" />
          </div>
          <h2 className="text-lg font-bold text-slate-900">This feature needs the {needed} plan</h2>
          <p className="text-sm text-slate-500">
            Your workshop is on the <span className="font-semibold capitalize">{subscription}</span> plan.
            Ask your administrator to upgrade the workshop subscription to unlock this module.
          </p>
        </Card>
      </div>
    </Layout>
  );
};

export default FeatureGate;
